// @flow
import type { Contracts } from 'digicel-kaizen-library';

export type ContractsActionType =
  | {|
      type: 'FETCH_CONTRACTS',
    |}
  | {|
      type: 'FETCH_CONTRACTS_SUCCESS',
      payload: {|
        contracts: Contracts,
      |},
    |}
  | {|
      type: 'FETCH_CONTRACTS_FAILURE',
      payload: {|
        error: any,
      |},
    |};

export const fetchContracts = (): ContractsActionType => ({
  type: 'FETCH_CONTRACTS',
});

export const fetchContractsSuccess = (contracts: Contracts): ContractsActionType => ({
  type: 'FETCH_CONTRACTS_SUCCESS',
  payload: {
    contracts,
  },
});

export const fetchContractsFailure = (error: any): ContractsActionType => ({
  type: 'FETCH_CONTRACTS_FAILURE',
  payload: {
    error,
  },
});
